export default __webpack_public_path__ + "static/media/marker-red.64226642.svg";